<template>
  <div class="h-full w-full flex justify-center items-center">
    <base-dialog :show="!!error" title="An error occurred" @close="handleError">
      <p>{{ error }}</p>
    </base-dialog>
    <base-dialog :show="isLoading" title="Authenticating..." fixed>
      <base-spinner></base-spinner>
    </base-dialog>
    <base-card>
      <form @submit.prevent="submitForm" class="p-4 w-480">
        <div class="flex justify-center">
          <img class="h-20" src="../../assets/images/logo.png" />
        </div>
        <h1 class="text-center w-full text-xl font-medium">Client Login</h1>
        <div class="">
          <label for="username">Username</label>
          <input type="text" id="username" v-model.trim="username" />
        </div>
        <div class="mt-4">
          <label for="password">Password</label>
          <input
            type="password"
            id="password"
            autocomplete="off"
            v-model.trim="password"
          />
        </div>
        <div v-if="totpRequired" class="mt-4">
          <label for="code">Two-Factor Code</label>
          <input
            type="text"
            id="code"
            inputmode="numeric"
            maxlength="6"
            autocomplete="one-time-code"
            placeholder="6-digit code"
            v-model.trim="code"
            ref="codeInput"
          />
          <p v-if="totpError" class="text-xs text-red-600 mt-1">{{ totpError }}</p>
          <p v-else class="text-xs text-gray-500 mt-1">Open your authenticator app and enter the current 6-digit code.</p>
        </div>
        <label v-if="!totpRequired" class="remember-label mt-3 text-sm cursor-pointer select-none">
          <input type="checkbox" v-model="rememberMe" />
          <span>Keep me logged in for 7 days</span>
        </label>
        <p v-if="!formIsValid" class="text-xs text-red-600">
          Please enter a valid username and password.
        </p>
        <div class="flex justify-center mt-4">
          <base-button>{{ totpRequired ? 'Verify' : 'Login' }}</base-button>
        </div>
      </form>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      code: "",
      rememberMe: false,
      totpRequired: false,
      totpError: null,
      formIsValid: true,
      isLoading: false,
      error: null,
    };
  },
  methods: {
    async submitForm() {
      this.formIsValid = true;
      if (this.username === "" || this.password === "") {
        this.formIsValid = false;
        return;
      }

      this.isLoading = true;

      const actionPayload = {
        username: this.username,
        password: this.password,
        ...(this.totpRequired && this.code ? { code: this.code } : {}),
        rememberMe: this.rememberMe,
      };

      try {
        await this.$store.dispatch("clientLogin", actionPayload);
        const redirectUrl = "/" + (this.$route.query.redirect || "dashboard");
        this.$router.replace(redirectUrl);
      } catch (err) {
        if (err && err.totpRequired) {
          this.totpRequired = true;
          this.totpError = err.totpInvalid ? (err.message || "Invalid two-factor code.") : null;
          this.code = "";
          this.$nextTick(() => { try { this.$refs.codeInput && this.$refs.codeInput.focus(); } catch (_) { /* focus is best-effort */ } });
          this.isLoading = false;
          return;
        }
        this.error =
          err.response?.data?.message ||
          err.message ||
          "Failed to authenticate, try later.";
      }

      this.isLoading = false;
    },
    handleError() {
      this.error = null;
    },
  },
};
</script>

<style scoped>
@responsive {
  .w-480 {
    width: 480px;
  }
}

label {
  font-weight: bold;
  margin-bottom: 0.5rem;
  display: block;
}

/* Remember-me row: the generic `label` (display:block) and `input`
   (display:block; width:100%) rules above would stack a full-width
   checkbox over the text. Scope under .remember-label to win on
   specificity and render an inline checkbox + label with spacing. */
.remember-label {
  display: flex;
  align-items: center;
  font-weight: normal;
  margin-bottom: 0;
}
.remember-label input[type="checkbox"] {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 0 8px 0 0;
  padding: 0;
  flex-shrink: 0;
}

input,
textarea {
  display: block;
  width: 100%;
  font: inherit;
  border: 1px solid #ccc;
  padding: 0.15rem;
}

input:focus,
textarea:focus {
  border-color: #3d008d;
  background-color: #faf6ff;
  outline: none;
}
</style>